const myRouter = [
  {
    path: '/my',
    name: 'MyIndex',
    component: () => import('@/views/my/index')
  },
  {
    path: '/my/about',
    name: 'MyAbout',
    component: () => import('@/views/my/about')
  },
  {
    path: '/my/profile',
    name: 'MyProfile',
    component: () => import('@/views/my/profile')
  },
  {
    path: '/my/debug',
    name: 'MyDebug',
    component: () => import('@/views/my/debug')
  },
  {
    path: '/my/personal',
    name: 'MyPersonal',
    component: () => import('@/views/my/personal')
  },
  {
    path: '/my/avatar/edit',
    name: 'MyAvatarEdit',
    component: () => import('@/views/my/edit/avatar')
  },
  {
    path: '/my/topics',
    name: 'MyTopics',
    component: () => import('@/views/my/topics')
  },
  {
    path: '/my/topic/fav',
    name: 'MyFavTopic',
    component: () => import('@/views/my/fav_topic')
  },
  {
    path: '/my/replies',
    name: 'MyReplies',
    component: () => import('@/views/my/replies')
  },
  {
    path: '/my/coin',
    name: 'MyCoin',
    component: () => import('@/views/my/coin')
  },
  {
    path: '/my/eps',
    name: 'MyEps',
    component: () => import('@/views/my/eps')
  },
  {
    path: '/my/ep/:id(\\d+)',
    name: 'MyEp',
    component: () => import('@/views/my/ep')
  },
  {
    path: '/my/orders',
    name: 'MyOrders',
    component: () => import('@/views/my/orders')
  },
  {
    path: '/my/order/:id(\\d+)',
    name: 'MyOrder',
    component: () => import('@/views/my/order')
  },
  {
    path: '/my/mobile/edit',
    name: 'MyMobileEdit',
    component: () => import('@/views/my/edit/mobile')
  }
]

export default myRouter



// WEBPACK FOOTER //
// ./src/router/modules/my.js